// extracted by mini-css-extract-plugin
export var base = "_1s-0";
export var updateBanner = "_1s-1";